import { useState } from 'react'
import { useNotifications } from '../contexts/NotificationContext'
import './Settings.css'
import FamilyRelationshipManager from '../components/FamilyRelationshipManager'

const Settings = () => {
  const { settings, updateSettings, isPermissionGranted } = useNotifications()
  const [activeSection, setActiveSection] = useState('notifications')

  const handleSettingChange = (category, setting, value) => {
    updateSettings({
      [category]: {
        ...settings[category],
        [setting]: value
      }
    })
  }

  const requestNotificationPermission = async () => {
    if ('Notification' in window) {
      const permission = await Notification.requestPermission()
      if (permission === 'granted') {
        window.location.reload()
      }
    }
  }

  const sections = [
    { id: 'notifications', title: 'Notificações', icon: '🔔' },
    { id: 'privacy', title: 'Privacidade', icon: '🔒' },
    { id: 'appearance', title: 'Aparência', icon: '🎨' },
    { id: 'account', title: 'Conta', icon: '👤' }
  ]

  return (
    <div className="settings-page">
      <div className="settings-header">
        <h1>Configurações</h1>
        <p>Personalize sua experiência no Domusfamilyhub</p>
      </div>

      <div className="settings-container">
        {/* Sidebar */}
        <div className="settings-sidebar">
          {sections.map(section => (
            <button
              key={section.id}
              className={`settings-nav-item ${activeSection === section.id ? 'active' : ''}`}
              onClick={() => setActiveSection(section.id)}
            >
              <span className="nav-icon">{section.icon}</span>
              <span className="nav-title">{section.title}</span>
            </button>
          ))}
        </div>

        {/* Content */}
        <div className="settings-content">
          {activeSection === 'notifications' && (
            <div className="settings-section">
              <h2>Configurações de Notificações</h2>
              
              {/* Status das permissões */}
              <div className="permission-status">
                <div className="permission-item">
                  <span className="permission-icon">
                    {isPermissionGranted ? '✅' : '❌'}
                  </span>
                  <div className="permission-info">
                    <h4>Notificações Push</h4>
                    <p>
                      {isPermissionGranted 
                        ? 'Permissão do navegador concedida. O envio automático de notificações ainda não está configurado.'
                        : 'Permissão não concedida. O envio automático de notificações ainda não está configurado.'
                      }
                    </p>
                  </div>
                  {!isPermissionGranted && (
                    <button 
                      className="enable-button"
                      onClick={requestNotificationPermission}
                    >
                      Ativar
                    </button>
                  )}
                </div>
              </div>

              {/* Adicionar na seção de família */}
         <div className="space-y-6">
       {/* Existing family settings */}
  
      {/* Relacionamentos Familiares */}
    <FamilyRelationshipManager />
  </div>


              {/* Configurações por categoria */}
              <div className="notification-categories">
                {/* Tarefas */}
                <div className="category-section">
                  <div className="category-header">
                    <h3>📋 Tarefas</h3>
                    <label className="toggle-switch">
                      <input
                        type="checkbox"
                        checked={settings.tasks.enabled}
                        onChange={(e) => handleSettingChange('tasks', 'enabled', e.target.checked)}
                      />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                  
                  {settings.tasks.enabled && (
                    <div className="category-options">
                      <div className="option-item">
                        <label>
                          <input
                            type="checkbox"
                            checked={settings.tasks.dueSoon}
                            onChange={(e) => handleSettingChange('tasks', 'dueSoon', e.target.checked)}
                          />
                          Tarefas vencendo em breve
                        </label>
                      </div>
                      <div className="option-item">
                        <label>
                          <input
                            type="checkbox"
                            checked={settings.tasks.overdue}
                            onChange={(e) => handleSettingChange('tasks', 'overdue', e.target.checked)}
                          />
                          Tarefas em atraso
                        </label>
                      </div>
                      <div className="option-item">
                        <label>
                          <input
                            type="checkbox"
                            checked={settings.tasks.completed}
                            onChange={(e) => handleSettingChange('tasks', 'completed', e.target.checked)}
                          />
                          Tarefas concluídas
                        </label>
                      </div>
                    </div>
                  )}
                </div>

                {/* Eventos */}
                <div className="category-section">
                  <div className="category-header">
                    <h3>📅 Eventos</h3>
                    <label className="toggle-switch">
                      <input
                        type="checkbox"
                        checked={settings.events.enabled}
                        onChange={(e) => handleSettingChange('events', 'enabled', e.target.checked)}
                      />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                  
                  {settings.events.enabled && (
                    <div className="category-options">
                      <div className="option-item">
                        <label>
                          <input
                            type="checkbox"
                            checked={settings.events.reminders}
                            onChange={(e) => handleSettingChange('events', 'reminders', e.target.checked)}
                          />
                          Lembretes de eventos
                        </label>
                      </div>
                      <div className="option-item">
                        <label>
                          Lembrar com antecedência:
                          <select
                            value={settings.events.reminderTime}
                            onChange={(e) => handleSettingChange('events', 'reminderTime', parseInt(e.target.value))}
                          >
                            <option value={15}>15 minutos</option>
                            <option value={30}>30 minutos</option>
                            <option value={60}>1 hora</option>
                            <option value={120}>2 horas</option>
                            <option value={1440}>1 dia</option>
                          </select>
                        </label>
                      </div>
                    </div>
                  )}
                </div>

                {/* Orçamento */}
                <div className="category-section">
                  <div className="category-header">
                    <h3>💰 Orçamento</h3>
                    <label className="toggle-switch">
                      <input
                        type="checkbox"
                        checked={settings.budget.enabled}
                        onChange={(e) => handleSettingChange('budget', 'enabled', e.target.checked)}
                      />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                  
                  {settings.budget.enabled && (
                    <div className="category-options">
                      <div className="option-item">
                        <label>
                          <input
                            type="checkbox"
                            checked={settings.budget.alerts}
                            onChange={(e) => handleSettingChange('budget', 'alerts', e.target.checked)}
                          />
                          Alertas de orçamento
                        </label>
                      </div>
                      <div className="option-item">
                        <label>
                          <input
                            type="checkbox"
                            checked={settings.budget.monthlyReport}
                            onChange={(e) => handleSettingChange('budget', 'monthlyReport', e.target.checked)}
                          />
                          Relatório mensal
                        </label>
                      </div>
                    </div>
                  )}
                </div>

                {/* Manutenção */}
                <div className="category-section">
                  <div className="category-header">
                    <h3>🔧 Manutenção</h3>
                    <label className="toggle-switch">
                      <input
                        type="checkbox"
                        checked={settings.maintenance.enabled}
                        onChange={(e) => handleSettingChange('maintenance', 'enabled', e.target.checked)}
                      />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                  
                  {settings.maintenance.enabled && (
                    <div className="category-options">
                      <div className="option-item">
                        <label>
                          <input
                            type="checkbox"
                            checked={settings.maintenance.reminders}
                            onChange={(e) => handleSettingChange('maintenance', 'reminders', e.target.checked)}
                          />
                          Lembretes de manutenção
                        </label>
                      </div>
                    </div>
                  )}
                </div>

                {/* Compras */}
                <div className="category-section">
                  <div className="category-header">
                    <h3>🛒 Compras</h3>
                    <label className="toggle-switch">
                      <input
                        type="checkbox"
                        checked={settings.shopping.enabled}
                        onChange={(e) => handleSettingChange('shopping', 'enabled', e.target.checked)}
                      />
                      <span className="toggle-slider"></span>
                    </label>
                  </div>
                  
                  {settings.shopping.enabled && (
                    <div className="category-options">
                      <div className="option-item">
                        <label>
                          <input
                            type="checkbox"
                            checked={settings.shopping.listUpdates}
                            onChange={(e) => handleSettingChange('shopping', 'listUpdates', e.target.checked)}
                          />
                          Atualizações da lista
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Configurações gerais */}
              <div className="general-settings">
                <h3>Configurações Gerais</h3>
                
                <div className="option-item">
                  <label>
                    <input
                      type="checkbox"
                      checked={settings.general.sound}
                      onChange={(e) => handleSettingChange('general', 'sound', e.target.checked)}
                    />
                    Som das notificações
                  </label>
                </div>

                <div className="option-item">
                  <label>
                    <input
                      type="checkbox"
                      checked={settings.general.vibration}
                      onChange={(e) => handleSettingChange('general', 'vibration', e.target.checked)}
                    />
                    Vibração (dispositivos móveis)
                  </label>
                </div>

                <div className="option-item">
                  <label>
                    Não perturbe:
                    <div className="time-range">
                      <input
                        type="time"
                        value={settings.general.quietHours.start}
                        onChange={(e) => handleSettingChange('general', 'quietHours', {
                          ...settings.general.quietHours,
                          start: e.target.value
                        })}
                      />
                      <span>até</span>
                      <input
                        type="time"
                        value={settings.general.quietHours.end}
                        onChange={(e) => handleSettingChange('general', 'quietHours', {
                          ...settings.general.quietHours,
                          end: e.target.value
                        })}
                      />
                    </div>
                  </label>
                </div>
              </div>
            </div>
          )}

          {activeSection === 'privacy' && (
            <div className="settings-section">
              <h2>Privacidade</h2>
              <p>Configurações de privacidade em desenvolvimento...</p>
            </div>
          )}

          {activeSection === 'appearance' && (
            <div className="settings-section">
              <h2>Aparência</h2>
              <p>Configurações de aparência em desenvolvimento...</p>
            </div>
          )}

          {activeSection === 'account' && (
            <div className="settings-section">
              <h2>Conta</h2>
              <p>Configurações de conta em desenvolvimento...</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Settings